<div class="checkbox" [ngStyle]="{'background-image': 'url(' + imagePath + ')'}">
    <label [for]="name" class="icon-check checkbox__input" [ngClass]="{'checkbox__input--checked': checked}">
        <input type="checkbox" [attr.checked]="checked ? checked : null" [id]="name" (change)="toggleVisibility($event)" />
    </label>
    <div class="checkbox__label">
        {{ label }}
    </div>
</div>
